import { render } from "./DebtConsolidationCalculator.vue?vue&type=template&id=48807253&scoped=true"
import script from "./DebtConsolidationCalculator.vue?vue&type=script&lang=js"
export * from "./DebtConsolidationCalculator.vue?vue&type=script&lang=js"

import "./DebtConsolidationCalculator.vue?vue&type=style&index=0&id=48807253&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48807253"]])

export default __exports__